
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { CreditsProvider } from "@/hooks/useCredits";
import ProtectedRoute from "@/components/ProtectedRoute";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import PaymentSuccess from "./pages/PaymentSuccess";
import TransactionHistory from "./pages/TransactionHistory";
import PaperAnalyzer from "./pages/PaperAnalyzer";
import InterviewCoverStatic from "./pages/InterviewCoverStatic";

import CreditStore from "./components/CreditStore";
import NotFound from "./pages/NotFound";

// Environment flag to enable/disable authentication
const USE_MOCK_AUTH = import.meta.env.VITE_USE_MOCK_AUTH === 'true';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <CreditsProvider>
              <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/payment-success" element={
                USE_MOCK_AUTH ? (
                  <PaymentSuccess />
                ) : (
                  <ProtectedRoute>
                    <PaymentSuccess />
                  </ProtectedRoute>
                )
              } />
              <Route path="/credits" element={
                USE_MOCK_AUTH ? (
                  <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-red-50">
                    <CreditStore />
                  </div>
                ) : (
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-red-50">
                      <CreditStore />
                    </div>
                  </ProtectedRoute>
                )
              } />
              <Route path="/transactions" element={
                USE_MOCK_AUTH ? (
                  <TransactionHistory />
                ) : (
                  <ProtectedRoute>
                    <TransactionHistory />
                  </ProtectedRoute>
                )
              } />
              <Route path="/paper-analyzer" element={
                USE_MOCK_AUTH ? (
                  <PaperAnalyzer />
                ) : (
                  <ProtectedRoute>
                    <PaperAnalyzer />
                  </ProtectedRoute>
                )
              } />
              <Route path="/interview-cover" element={
                USE_MOCK_AUTH ? (
                  <InterviewCoverStatic />
                ) : (
                  <ProtectedRoute>
                    <InterviewCoverStatic />
                  </ProtectedRoute>
                )
              } />
              <Route path="/" element={
                USE_MOCK_AUTH ? (
                  <Index />
                ) : (
                  <ProtectedRoute>
                    <Index />
                  </ProtectedRoute>
                )
              } />
              <Route path="*" element={<NotFound />} />
              </Routes>
            </CreditsProvider>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
);

export default App;
